import React from "react";
import FinalCtaPanel from "../../components/FinalCtaPanel";
import { finalCtaContent } from "./servicesContent";

const ServicesFinalCta = () => (
  <FinalCtaPanel
    id="services-final-cta-heading"
    title={finalCtaContent.title}
    paragraph={finalCtaContent.paragraph}
    cta={finalCtaContent.cta}
    image="/assets/cta/certification-journey.webp"
  />
);

export default ServicesFinalCta;
